import { GetStaticProps } from "next";
import { getPosts, BlogPost } from "@/utils/getPosts";
import { NextSeo } from "next-seo";
import Link from "next/link";
import BlogCard from "@/components/blog/BlogCard";
import MainLayout from "@/components/layouts/MainLayout";

interface HomeProps {
  posts: BlogPost[];
}

export default function Home({ posts }: HomeProps) {
  return (
    <>
      <NextSeo
        title="Amrik Malhans - Web Performance & Engineering"
        description="Thoughts & notes on web performance and browser engineering"
        canonical="https://amrik.live"
        openGraph={{
          url: "https://amrik.live",
          title: "Amrik Malhans - Web Performance & Engineering",
          description:
            "Thoughts & notes on web performance and browser engineering",
          images: [
            {
              url: "https://uoubfkdsc2yugclb.public.blob.vercel-storage.com/banner.jpeg",
              width: 1200,
              height: 630,
              alt: "Amrik Malhans Website",
            },
          ],
          siteName: "Amrik Malhans",
        }}
      />
      <MainLayout>
        <div className="flex flex-col gap-y-2 my-4">
          <h1 className="text-lg font-semibold text-zinc-900 dark:text-zinc-100">
            Welcome to my blog
          </h1>
          <p className="text-zinc-500 dark:text-zinc-400 text-sm md:text-base">
            This blog captures all my technical deep dives and learnings around web performance and browser engineering. 
            I am currently at <Link href="https://www.yottaa.com?utm_source=amrik.live&utm_medium=website&utm_campaign=website" target="_blank" className="text-zinc-900 dark:text-zinc-100">Yottaa</Link> 
            {" "}to help e-commerce brands become faster.{" "}
            Best way to reach out to me is via <Link href="https://www.linkedin.com/in/amrikmalhans/" target="_blank" className="text-zinc-900 dark:text-zinc-100">LinkedIn</Link>.
          </p>
        </div>

        {/* Blog Section */}
        <div className="w-full flex flex-col gap-y-4 my-6">
          <h2 className="font-semibold text-zinc-900 dark:text-zinc-100">
            Latest
          </h2>
          <div className="flex flex-col gap-y-4">
            {posts.map((post) => (
              <BlogCard
                key={post.slug}
                slug={post.slug}
                frontMatter={post.frontMatter}
              />
            ))}
          </div>
        </div>
      </MainLayout>
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  const posts = getPosts({ limit: 10 });

  return {
    props: {
      posts,
    },
  };
};
